// src/components/Contact.js
import React from 'react';
import './Contact.css';
import Navbar from './Navbar';
import Footer from './Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './styles/global/planetarium.css'; 
import PlanetBox from './PlanetBox';

const Contact = () => {
  // Function to handle the email action
  const handleEmail = () => {
    console.log("email link clicked");
    window.location.href = "mailto:v.lugerlin@gmail.com?subject=Career Opportunity for Vanessa!";
  };

  return (
    <div className="mail">
      <Navbar />
      <div id="clouds">
        <div className="cloud x5"></div>
        <div className="cloud x1"></div>
        <div className="cloud x7"></div>
        <div className="cloud x4"></div>
        <div className="cloud x6"></div>

        <img
          className="v-class"
          src="picz/icons/v-circuitheadphones.png"
          alt="Horseshoe Bend"
        />
        
        {/* Email Button */}
        <h2>
          <button onClick={handleEmail} className="email-button">
            Click here to email me
          </button>
        </h2>

        <div className="cloud x2"></div>

        <img 
          className='gypsyRoar'
          src="picz/roar.jpg"
          alt="Roar"
        />
        <h5>Hope to hear from you soon!</h5>

        <div className="cloud x3"></div>
        <div className="cloud x4"></div>
        <div className="cloud x5"></div>
        <div className="cloud x3"></div>
        <div className="cloud x8"></div>
        <PlanetBox />
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
